/* eslint-disable react/no-danger */
import { Modal } from '@orobix/orobix-fe-components'
import i18n from 'i18next'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import endUserManualEN from '../../assets/ai-go-studio-end-user-manual.pdf'
import endUserManualIT from '../../assets/ai-go-studio-manuale-utente.pdf'
import AnomalyHelperEN from '../../assets/anomalyHelperEN.md'
import AnomalyHelperIT from '../../assets/anomalyHelperIT.md'
import ClassificationHelperEN from '../../assets/classificationHelperEN.md'
import ClassificationHelperIT from '../../assets/classificationHelperIT.md'
import PatchClassificationHelperEN from '../../assets/patchClassificationHelperEN.md'
import PatchClassificationHelperIT from '../../assets/patchClassificationHelperIT.md'
import SegmentationHelperEN from '../../assets/segmentationHelperEN.md'
import SegmentationHelperIT from '../../assets/segmentationHelperIT.md'
import { ProductType } from '../../types'

export interface HtmlModalProps {
  productType: ProductType
  onCloseRequest: () => void
}

export const HtmlModal = ({ productType, onCloseRequest }: HtmlModalProps) => {
  const [fileContent, setFileContent] = useState('')
  const { t } = useTranslation()

  const doFetch = (requestInfo: RequestInfo) => {
    fetch(requestInfo)
      .then((res) => res.text())
      .then((text) => setFileContent(text))
  }

  useEffect(() => {
    if (productType === 'anomaly') {
      doFetch(
        i18n.language.startsWith('it') ? AnomalyHelperIT : AnomalyHelperEN
      )
    } else if (productType === 'classification') {
      doFetch(
        i18n.language.startsWith('it')
          ? ClassificationHelperIT
          : ClassificationHelperEN
      )
    } else if (productType === 'classification_patch') {
      doFetch(
        i18n.language.startsWith('it')
          ? PatchClassificationHelperIT
          : PatchClassificationHelperEN
      )
    } else if (productType === 'segmentation') {
      doFetch(
        i18n.language.startsWith('it')
          ? SegmentationHelperIT
          : SegmentationHelperEN
      )
    }
  }, [productType])

  return (
    <Modal
      size="lg"
      onCloseRequest={onCloseRequest}
      title={t('Tips for improving performance')}
    >
      <div dangerouslySetInnerHTML={{ __html: fileContent }} />
      <a
        target="_blank"
        href={
          i18n.language.startsWith('it') ? endUserManualIT : endUserManualEN
        }
        rel="noreferrer"
      >
        {t('End user manual (PDF)')}
      </a>
    </Modal>
  )
}

export default HtmlModal
